// extracted by mini-css-extract-plugin
module.exports = {"catContainer":"CategCard_catContainer__dJyut","catName":"CategCard_catName__QwRpz","catImage":"CategCard_catImage__1q2A7","catLink":"CategCard_catLink__3oZde"};